import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {
    bgAudio: null,
  },
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: true,
  firstMistake: false,
  cam: null,
  qnum: -1,
  correct: 0,
  attempts: 0,
  hneed: false,
  clicked: false,
  retry: false,
  hintClose: false,
};
